module.exports = __webpack_public_path__ + "static/media/discord.4dc92ff0.png";